import { Injectable } from '@angular/core';
import { BdHelpLink } from './help.model';
import { HELP_LINKS } from './help-links';

@Injectable({
  providedIn: 'root',
})
export class BdHelpService {
  public findByKey(key: string): Promise<BdHelpLink> {
    return Promise.resolve(HELP_LINKS[key]);
  }
}
